import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px dashed ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};

  .ant-radio-button-wrapper,
  .ant-radio-button-wrapper-checked,
  .image-upload-content,
  .ant-form-item-control-input-content input {
    background: ${({ theme }) => theme.colors.background1} !important;
  }

  .banner-extra-details-divider {
    margin: 0;
    font-size: 0.8rem;
  }
`;
